module.exports = __webpack_public_path__ + "img/instituciones.d611e2e3.png";